import React from 'react';
// import Launchpad from '@common/launchpad'
import Drawer from './components/common/new-drawer/paper-music';

import 'normalize.css'
import './root.css'

const App = () => {
  return (
    <Drawer/>
  );
}

export default App;
